<template>
  <v-container class="result-form">
    <v-row
      class="d-flex flex-column-reverse flex-md-row mx-0 align-center align-md-start"
    >
      <v-col cols="12" sm="10" md="7" class="pa-md-8 pa-lg-8 mb-10 mb-md-0">
        <v-row class="align-center mb-3 mb-md-10">
          <v-col>
            <div class="d-flex justify-end" style="visibility: hidden">
              <v-btn
                :color="treeData.isAdvance ? '#FFF777' : 'rgb(255 252 204)'"
                title="簡易樹木種類"
                class="ct-text-bolder d-flex justify-center align-center mr-4"
                :class="{ 'shadow-btn': !treeData.isAdvance }"
                @click="treeData.isAdvance = false"
              >
                <span style="display:inline-block">簡易樹木種類</span>
              </v-btn>
              <v-btn
                :color="!treeData.isAdvance ? '#FFF777' : 'rgb(255 252 204)'"
                title="進階樹木種類"
                class="ct-text-bolder d-flex justify-center align-center"
                :class="{ 'shadow-btn': treeData.isAdvance }"
                @click="treeData.isAdvance = true"
              >
                <span style="display:inline-block">進階樹木種類</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row class="align-start mb-3 mb-md-10 field-row">
          <v-col cols="auto" class="px-1 field-label-col">
            <label
              for="treeType"
              class="calculator-title font-weight-bold color-tree d-block"
            >
              樹木種類
            </label>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-autocomplete
              id="treeType"
              :value="treeData.type"
              item-text="Name"
              item-value="Sno"
              disabled
              dense
              placeholder="請選擇樹木種類"
              outlined
              solo
              hide-details
              :items="treeData.isAdvance ? treeCo2List : entryCo2List"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="align-start mb-2 field-row">
          <v-col
            cols="auto"
            class="px-1 field-label-col compare-title-spacer"
          ></v-col>
          <v-col class="px-1 text-center field-input-col">
            <span class="compare-title">基準值</span>
          </v-col>
          <v-col class="px-1 text-center field-input-col">
            <span class="compare-title">複測值</span>
          </v-col>
        </v-row>

        <v-row class="align-start mb-3 mb-md-10 field-row">
          <v-col cols="auto" class="px-1 field-label-col">
            <label
              for="treeHeight"
              class="calculator-title font-weight-bold color-tree d-block"
            >
              樹高 (公尺)
            </label>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-text-field
              id="treeHeight"
              :value="treeData.base.height"
              label="請輸入樹高 (公尺)"
              disabled
              solo
              :hide-details="true"
            ></v-text-field>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-text-field
              id="recheckTreeHeight"
              :value="treeData.recheck.height"
              label="請輸入樹高 (公尺)"
              disabled
              solo
              :hide-details="true"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="align-start mb-3 mb-md-10 field-row">
          <v-col cols="auto" class="px-1 field-label-col">
            <label
              for="treeDiameter"
              class="calculator-title font-weight-bold color-tree d-block"
            >
              胸高直徑 (公分)
            </label>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-text-field
              id="treeDiameter"
              :value="treeData.base.diameter"
              label="請輸入胸高直徑 (公分)"
              disabled
              solo
              :hide-details="true"
            ></v-text-field>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-text-field
              id="recheckTreeDiameter"
              :value="treeData.recheck.diameter"
              label="請輸入胸高直徑 (公分)"
              disabled
              solo
              :hide-details="true"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="align-start mb-3 mb-md-10 field-row">
          <v-col cols="auto" class="px-1 field-label-col">
            <label
              for="treePerimeter"
              class="calculator-title font-weight-bold color-tree d-block"
            >
              胸高周長 (公分)
            </label>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-text-field
              id="treePerimeter"
              :value="treeData.base.perimeter"
              label="請輸入胸高周長 (公分)"
              disabled
              solo
              :hide-details="true"
            ></v-text-field>
          </v-col>
          <v-col class="px-1 field-input-col">
            <v-text-field
              id="recheckTreePerimeter"
              :value="treeData.recheck.perimeter"
              label="請輸入胸高周長 (公分)"
              disabled
              solo
              :hide-details="true"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="align-start mb-3 mb-md-10 field-row">
          <v-col cols="auto" class="px-1 field-label-col">
            <label class="calculator-title font-weight-bold color-tree d-block">
              樹木固碳量 (公斤)
            </label>
          </v-col>
          <v-col class="px-1 text-center field-input-col">
            <div class="carbon-value">{{ baseCarbon }}</div>
          </v-col>
          <v-col class="px-1 text-center field-input-col">
            <div class="carbon-value">
              {{ hasRecheck ? recheckCarbon : "-" }}
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="5" class="px-5 pa-md-8 pa-lg-16 align-self-center">
        <h2 class="text-center" style="color:#776556;">{{ displayTitle }}</h2>
        <div class="text-center mt-5">
          <div class="carbon">
            <span class="carbon-number">{{ displayCarbon }}</span>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-center">
        <span class="carbon-note">
          樹木碳匯量（一段時間中的樹木生長差異情形） = 複測值固碳量 –
          基準值固碳量
        </span>
      </v-col>
    </v-row>

    <v-row class="d-flex align-center justify-center">
      <div class="text-center my-16">
        <v-btn
          :color="'#FFF777'"
          title="計算別棵樹"
          class="ct-text-bolder"
          @click="$emit('calculateAnother')"
        >
          <span style="display:inline-block">計算別棵樹</span>
          <img
            :src="iconArrowSrc"
            alt="計算別棵樹"
            title="計算別棵樹"
            class="ml-1"
          />
        </v-btn>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    baseCarbon: {
      type: String,
      default: "0"
    },
    recheckCarbon: {
      type: String,
      default: "0"
    },
    displayCarbon: {
      type: String,
      default: "0"
    },
    displayTitle: {
      type: String,
      default: "樹木固碳量"
    },
    hasRecheck: {
      type: Boolean,
      default: false
    },
    treeCo2List: {
      type: Array,
      default: () => {}
    },
    treeData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      entryCo2List: [
        {
          Sno: 1,
          Name: "闊葉樹"
        },
        {
          Sno: 2,
          Name: "針葉樹"
        },
        {
          Sno: 3,
          Name: "棕櫚科"
        }
      ],
      iconArrowSrc: require("@/assets/images/carbon/icon_arror.svg")
    };
  }
};
</script>
<style lang="scss" scoped>
.carbon {
  font-size: 1rem;
  line-height: 1.2;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  height: 30vh;
  width: 100%;
  color: #fff;
  background-image: url("~@/assets/images/carbon/carbon_bg.svg");
  background-size: contain;
  background-position: center;

  @media all and (max-width: 600px) {
    height: 20vh;
  }
}

.carbon-number {
  font-size: clamp(1.8rem, 3.4vw, 3.2rem);
  line-height: 1;
  font-weight: 700;
}

.compare-title {
  font-size: clamp(1.2rem, 2.1vw, 2rem);
  line-height: 1.1;
  color: #0f7c1f;
  font-weight: 700;
}

.carbon-value {
  font-size: clamp(1rem, 1.3vw, 1.6rem);
  line-height: 1.2;
  color: #776556;
  font-weight: 700;
  display: inline-block;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.calculator-title {
  @include px-size(font-size, 16, 1);
  @include px-size(line-height, 16, 1);
  font-size: 1.75rem;
  white-space: nowrap;
  color: #776556;
}

.field-row {
  flex-wrap: nowrap;
}

.field-label-col {
  flex: 0 0 auto;
  width: 14rem;
  max-width: 14rem;
}

.field-input-col {
  flex: 1 1 0;
  min-width: 0;
}

.carbon-note {
  font-size: clamp(0.95rem, 1.6vw, 1.25rem);
  line-height: 1.4;
  font-weight: 600;
  color: #d3273b;
}

@media all and (max-width: 600px) {
  .calculator-title {
    font-size: 1.3rem;
    line-height: 1.3;
  }
}

@media all and (max-width: 960px) {
  .result-form {
    overflow-x: visible;
    padding-bottom: 0.25rem;
  }

  .field-row {
    flex-wrap: wrap;
    min-width: 0;
  }

  .field-label-col {
    width: 100%;
    max-width: 100%;
    margin-bottom: 0.25rem;
  }

  .compare-title-spacer {
    display: none;
  }
}
</style>
